import Tracker from '@openreplay/tracker';

export const tracker = new Tracker({
	projectKey: "SnHo8eB3muCfEsB5M4F7",
	ingestPoint: "https://fusionawstest.co.uk/ingest",
});